import Vue from 'vue'
import App from './App.vue'
import router from './router'
import './assets/styles/main.css'
import request from './utils/request'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'leaflet/dist/leaflet.css';

Vue.config.productionTip = false

// 将axios挂载到Vue原型上
Vue.prototype.$http = request

Vue.use(ElementUI)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
